import partnerReferences from "./partnerReferences.json";

const references = [
  { name: "Osmanlı Doğal Taş", href: "https://osmanlidogaltas.com", logo: "osmanli-dogal-tas.svg", darkLogo: true },
  { name: "Deniz Doğal Taş", href: "https://denizdogaltas.com", logo: "deniz-dogal-tas.webp" },
  { name: "SAFF Doğal Taş", href: "https://saffdogaltas.com", logo: "saff-dogal-tas.webp" },
  { name: "Osmanlı Değerli Taş", href: "https://osmanlidegerlitas.com", logo: "osmanli-degerli-tas.svg" },
  { name: "Çakra Doğal Taş", href: "https://cakradogaltas.com", logo: "cakra-dogal-tas.svg" },
  { name: "Alp Doğal Taş", href: "https://alpdogaltas.com", logo: "alp-dogal-tas.png", darkLogo: true },
  { name: "Allday", href: "https://www.allday.com.tr", logo: "allday.png" },
  { name: "Webisso", href: "https://webisso.com/referances", logo: "webisso.svg" },
  { name: "ASRİ TECH", href: "https://www.asritech.com.tr/referanslar", logo: "asri-tech.png" },
  ...Object.values(partnerReferences).flat(),
];

export default references;
